<template>
    <div class="mb-3">
        <el-button class="block ml-auto" icon="el-icon-search" @click="showSearch = !showSearch">
            搜索{{storeInfo.type | formatVar('StoreType')}}
        </el-button>
        <transition name="el-zoom-in-top">
            <div v-show="showSearch" class="border rounded p-3 mt-2 pb-0 d-center-start flex-wrap">
                <left-text-border class="w-50 mb-3" leftText="门店名称" v-model="storeName" />
                <left-text-select class="w-50 mb-3" leftText="认证状态" :options="$GVAR.verifyType" v-model="storeVerify"/>
                <select-city class="mb-3 w-50"
                            leftText="省市区"
                            mutiBlocks
                            @getCityInfo="info => this.cityInfo = info"
                            :provinceId="cityInfo.province"
                            :cityId="cityInfo.city"
                            :districtIds="cityInfo.district.map(v => v.id)"/>
                <div class="w-50 mb-3 ml-auto text-right">
                <el-button type="primary" size="small" icon="el-icon-search" @click="$GFUN.pageChange(1);searchSubmit()">搜索</el-button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SearchCon',
    computed: {
      ...mapGetters(['storeInfo']),
    },
    data() {
      return {
        showSearch:false,
        storeName: '',
        storeVerify:'',
        cityInfo:{
          district:[]
        }
      }
    },
    methods:{
      //清空搜索条件
      initSearchCon() {
        this.storeName = '';
        this.storeVerify = '';
        this.cityInfo = {
          province:'',
          city:'',
          district:[]
        };
      },
      //提交搜索条件
      searchSubmit() {
        let data = {
          title:this.storeName,
          verify:this.storeVerify,
          pro:this.cityInfo.province,
          city:this.cityInfo.city,
          dis:this.cityInfo.district.map(v => v.id).join(','),
        }
        this.$emit('getSearchCon',data);
      },
    }
  }
</script>
